"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseTradingApi_1 = __importDefault(require("../src/TradingBot/BaseTradingApi"));
class BaseExchangeAPIAdapterImpl extends BaseTradingApi_1.default {
    cancelOrder(order) {
        throw "not implement";
    }
    createOrder(order) {
        throw "not implement";
    }
    getDepthData(base, quote) {
        throw "not implement";
    }
    getExchangeSymbolsObservable() {
        throw "not implement";
    }
    getTrades(base, quote) {
        throw "not implement";
    }
    queryCustomClosedOrdersRestApi(base, quote, orderId, limit) {
        throw "not implement";
    }
    queryCustomOpenOrdersRestApi(base, quote, orderId, limit) {
        throw "not implement";
    }
    cancelCustomOrder(order) {
        throw "not implement";
    }
    createMarketOrder(order) {
        throw "not implement";
    }
    createCustomOrder(order) {
        throw "not implement";
    }
}
exports.default = BaseExchangeAPIAdapterImpl;
